import React, { use, useEffect } from "react";
import StockCommentForm from "./StockCommentForm/StockCommentForm";
import { getCommentAPI, postCommentAPI, deleteCommentAPI } from "../../Services/CommentService";
import { toast } from "react-toastify";
import { CommentGet } from "../../Models/Comment";
import { set } from "react-hook-form";
import { get } from "http";
import { FaSpinner } from "react-icons/fa";
import StockCommentList from "../StockCommentList/StockCommentList";
import { FaRegCommentDots } from "react-icons/fa";

type Props = {
  stockSymbol: string;
};

type CommentFormInputs = {
  content: string;
};

const StockComment = ({ stockSymbol }: Props) => {
  const [comments, setComments] = React.useState<CommentGet[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  useEffect(() => {
    getComments();
  }, []);

  const handleComment = (e: CommentFormInputs) => {
    postCommentAPI(stockSymbol, e.content)
      .then((response) => {
        if (response) {
          toast.success("Comment posted successfully!");
          getComments();
        }
      })
      .catch((e) => {
        toast.error("Failed to post comment.");
        toast.warning(e);
      });
  };

  const handleDeleteComment = (id: number) => {
    deleteCommentAPI(id)
      .then((response) => {
        if (response) {
          toast.success("Comment deleted successfully!");
          getComments();
        }
      })
      .catch((e) => {
        toast.error("Failed to delete comment.");
        toast.warning(e);
      });
  };

  const getComments = () => {
    setIsLoading(true);
    getCommentAPI(stockSymbol).then((response) => {
      setIsLoading(false);
      if (response && response.data) {
        setComments(response?.data!);
      }
    });
  };
  return (
    <div className="flex flex-col">
      <h2 className="pl-6 pb-1 text-xl font-bold text-black flex items-center gap-2">
        {comments.length} {comments.length === 1 ? "comment" : "comments"}
        <FaRegCommentDots className="text-lg" />
      </h2>
      <div className="ml-4 mb-3 border-b-4 border-gray-400 w-full" />
      {isLoading ? (
        <FaSpinner />
      ) : (
        <StockCommentList comments={comments!} onDelete={handleDeleteComment} />
      )}
      <StockCommentForm symbol={stockSymbol} handleComment={handleComment} />
    </div>
  );
};

export default StockComment;
